export default __webpack_public_path__ + "4f9d14f95ec66ab2a6bdf6839981f174.png";